import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { doLogOut, getWhoAmI } from '../auth/authActions'
import {
  getUserDto,
  hasAnyRole,
  isAuthenticated,
  isEmailVerificationInProgress,
  getUserCompanies,
  hasRoleInCompany,
} from '../auth/authSelectors'
import { getCurrentRoute } from './RouterSelector'
import { IDispatchProps, IStateProps, Routes } from './Routes'
import { CompanyId, Role } from '../../services/api.types'
import { clearSuperAdminTargetCompany } from '../../views/SuperAdmin/store/SuperAdminActions'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  hasAnyRole: (roles: Role[]) => hasAnyRole(state, roles),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  // Treat a mid-verification session as NOT authenticated for the Navbar / Routes UI, so the
  // profile dropdown and other authenticated navigation hide and the user can only interact
  // with the verify screen itself.
  authenticated: isAuthenticated(state) && !isEmailVerificationInProgress(state),
  currentRoute: getCurrentRoute(state),
  userDto: getUserDto(state),
  userCompanies: getUserCompanies(state),
  superAdminTargetCompanyName: state.superAdmin?.targetCompany?.companyName || null,
})

const mapDispatchToProps: IDispatchProps = {
  doLogOut,
  getWhoAmI,
  clearSuperAdminTargetCompany,
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
